/* ---------- CROSSBROWSER BEGIN ---------- */
var $DOM = document.getElementsByTagName('html')[0];
var userAgent = detect.parse(navigator.userAgent),
    browserFamily = userAgent.browser.family,
    browserVersion = userAgent.browser.major;
//for Safari
if(browserFamily === 'Safari' || browserFamily === 'Mobile Safari') $DOM.classList.add('on-safari-' + browserVersion);
//for IE
if(browserFamily === 'IE' || browserFamily === 'IE Mobile') $DOM.classList.add('on-ie-' + browserVersion);
/* ---------- CROSSBROWSER END ---------- */

/* ---------- COPY PASTE BEGIN ---------- */
function initCopyPaste(){
  if(!document.querySelectorAll('.copyPaste').length) return;
  var copyBtn = document.querySelectorAll('.copyPaste');
  for(var i = 0; i < copyBtn.length; i++){
    copyBtn[i].addEventListener('click', copyText);
  }
}
function highlightText(text){
  text.classList.add('copyPaste-copy');
}
function removeChild(el) {
  if(el.parentNode != null) el.parentNode.removeChild(el);
}
function copyText(e){
  e.stopPropagation(), e.preventDefault();
  var el = e.target;
  var copyPasteBox = el.parentNode;
  var text = copyPasteBox.querySelector('.copyPaste-text');
  var $input = document.createElement('input');
  e.mousedown = highlightText(text);
  text.classList.add('copyPaste-copy');
  document.documentElement.appendChild($input);
  $input.value = text.textContent;
  $input.select();
  document.execCommand('copy');
  removeChild($input);
  setTimeout(function () {
    text.classList.remove('copyPaste-copy');
  },500);
}
/* ---------- COPY PASTE END ---------- */
$(window).on('load resize', function() {

  var w = $(window).width(),
    w_tab = $('.content__tab_link-current').width(),
    w_pair = $('.pair_item_icon img').width();

  //for hamburger (w >= 1200)
  if (w > 991) {
    $('aside').removeClass('aside-show');
    $('#nav-hamburger').prop('checked', '');
  }

  //for aside_nav-guests
  var checkGuests = document.getElementById('nav-guests');
  if (checkGuests){
    if (w > 1200) {
      checkGuests.checked = true;
      checkGuests.setAttribute('checked', 'checked');
    }else{
      checkGuests.checked = false;
      checkGuests.removeAttribute('checked');
    }
  }

  //for TAB MENU
  if (w < 767) {
    $('.content__tab_link-current').append('<div class="content__tab_link-current-line"></div>');
    $('.content__tab_link-current-line').css('width', w_tab);
  }
  $('.content__tab_link').on('click', function() {
    var link = $(this).attr('data-switch'),
      w_tab = $(this).width();

    if (link == "#search") {
      $('.content__tab-more').addClass('hidden');
    } else {
      $('.content__tab-more').removeClass('hidden');
    }
    $('.content__tab_link').removeClass('content__tab_link-current');
    $(this).addClass('content__tab_link-current');
    $('.content__tab_window').addClass('hide');
    $(link).removeClass('hide');
    if (w < 767) {
      $('.content__tab_link-current-line').remove();
      $(this).append('<div class="content__tab_link-current-line"></div>');
      $('.content__tab_link-current-line').css('width', w_tab);
    }
  });

  //for PAIR_ITEM_TITLE and PAIR_ITEM_TEXT width
  $('.pair_item_title').css('width', w_pair * 0.7);
  $('.pair_item_text').css('width', w_pair * 0.9);

  //for REGISTRATION FORM
  $('.registr_buton').on('click', function() {
    if ($('.header__login-show').length > 0) {
      $('.header__login-close').click();
    }

    if ($('.header__registration-show').length == 0) {
      $('.header__registration').addClass('header__registration-show');
      // reCaptchaInclude();
      $('#userlogin').focus();
    }

    $('body,html').animate({scrollTop: 0}, 500);

    //        $('.header__content_slogan').addClass('header__content_slogan-hide');
    //        $('.header__content_btn-orange').addClass('header__content_btn-orange-hide');


    return false;
  });
  $('.header__registration-close').on('click', function() {
    $('.header__registration').removeClass('header__registration-show');
    //        $('.header__content_slogan').removeClass('header__content_slogan-hide');
    //        $('.header__content_btn-orange').removeClass('header__content_btn-orange-hide');
  });

  $('.login_buton').on('click', function() {
    if ($('.header__registration-show').length > 0) {
      $('.header__registration-close').click();
    }

    if ($('.header__login-show').length == 0) {
      $('.header__login').addClass('header__login-show');
      $('#loginfields').focus();
    }

    //$('.header__content_slogan').addClass('header__content_slogan-hide');
    //$('.header__content_btn-orange').addClass('header__content_btn-orange-hide');

    $('body,html').animate({scrollTop: 0}, 500);
    return false;
  });
  $('.header__login-close').on('click', function() {
    $('.header__login').removeClass('header__login-show');
    //        $('.header__content_slogan').removeClass('header__content_slogan-hide');
    //        $('.header__content_btn-orange').removeClass('header__content_btn-orange-hide');
  });

  var timer = setInterval(function() {
    var w = $(window).width(),
      h = $('.header').height(),
      h_top = $('.header__top').height(),
      h_bottom = $('.header__bottom').height();

    // for HEADER REGISTRATION HEIGHT AND POSITION
    if ($('.header__registration').length != 0 || $('.header__login').length != 0) {
      if (w > 991) {
        $('.header__registration, .header__login').css({'top': $('.header__top').css('height').replace('px', '') - $('header').position().top});
      }
      if ((w > 480) && (w < 991)) {
        $('.header__registration, .header__login').css({'top': $('.header__bg').position().top});
      }
      if (w < 480) {
        $('.header__registration, .header__login').css('top', 0);
      }
      if (w > 1530) {
        $('.header__registration, .header__login').css('height', h - h_top - h_bottom + $('header').position().top);
      }
      if (w < 991) {
        $('.header__registration, .header__login').css({'height': 'auto'});
      }
    }

    clearInterval(timer);
  }, 50);

  //for PICT_RESPONSIVE
  if ($(".pict_responsive").length != 0) {
    $(".pict_responsive").find('img').each(function() {
      var pict = $(this),
        pictWidth = pict.width(),
        pictHeight = pict.height();
      if (pictWidth / pictHeight > 1.1) {
        pict.css({'width': '100%', 'height': 'auto'});
      } else {
        pict.css({'width': 'auto', 'height': '100%'});
      }
    });
  }
  //for PAGE: GIFT COMPLETED, GIFT PENDING
  $('.gift-full').find('.text-input,.textarea').prop('disabled', 'disabled');

  //for SELECTATOR PLUGIN
  $('.select:not(.select-destroy)').selectator({
    useSearch                : false,
    selectFirstOptionOnSearch: false
  });
  $('#country.select:not(.select-destroy)').selectator();

  var sliderPair = $(".pair__slider");
  if (sliderPair.length) {
    if ($(window).width() < 991) {
      // for PAIR__SLIDER
      sliderPair.not('.slick-initialized').slick({
        dots          : false,
        arrows        : true,
        infinite      : true,
        speed         : 1000,
        //autoplay: true,
        //autoplaySpeed: 2000,
        slidesToShow  : 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive    : [
          {
            breakpoint: 767,
            settings  : {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings  : {
              slidesToShow: 1
            }
          }
        ]
      });

    } else {
      sliderPair.filter('.slick-initialized').slick('unslick');
    }
  }

  //for tooltipVerified icon
  $(document)
    .off('mouseenter.tooltipVerified mouseleave.tooltipVerified', '#verifiedIcon')
    .on('mouseenter.tooltipVerified', '#verifiedIcon', function () {
      $(this).find('#tooltipVerified').show();
    })
    .on('mouseleave.tooltipVerified', '#verifiedIcon', function () {
      $(this).find('#tooltipVerified').hide();
    });
});

$(document).ready(function() {
  var sliderMain = $(".content__slider");
  // for CONTENT__SLIDER
  if (sliderMain.length) {
    sliderMain.slick({
      dots          : false,
      arrows        : true,
      infinite      : true,
      speed         : 1000,
      autoplay      : true,
      autoplaySpeed : 5000,
      slidesToShow  : 6,
      slidesToScroll: 1,
      responsive    : [
        {
          breakpoint: 1500,
          settings  : {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 1200,
          settings  : {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 767,
          settings  : {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings  : {
            slidesToShow: 1
          }
        }
      ]
    }).css({"opacity": 1})
  }
  // for Copy Paste
  initCopyPaste();
});

$(function() {
  //for SEARCH ICON
  function expand() {
    $(".search-input").toggleClass("square");
    $(".search_buton").delay(500).toggleClass("close");
    if ($('.search_buton').hasClass('close') == true) {
      $('.search-input').focus();
      $(this).parents('.form').find('[class*="form__btn"]').delay(1000).fadeIn(500);
      $(this).parent().find('.label').fadeOut();
    } else {
      $('.search-input').blur();
      $(this).parents('.form').find('[class*="form__btn"]').fadeOut();
      $(this).parent().find('.label').delay(1000).fadeIn();
    }
  }

  $('.search_buton').on('click', expand);


  //<----- begin for FORM ----->

  //for RECAPTCHA GOOGLE
  /*    var onloadCallback = function () {
   grecaptcha.enterprise.render( '.form__recaptcha' , { 'sitekey' : 'your_site_key' });
   };*/


  //for PASSWORD INPUT EYE-ICON (show or hide password)
  $('.password__buton').click(function() {
    var type = $(this).parent().find('input').attr('type') == "text" ? "password" : 'text';
    $(this).toggleClass('password-show');
    $(this).parent().find('input').prop('type', type);
  });

  //for RANGE INPUT
  if ($('.range-input').length != 0) {
    $('.range-input[type="range"]').each(function(index) {
      var value = $('.range-input[type="range"]').attr('data-values').split(' '),
        clone = $('.range-input[type="range"]').clone();
      $('.range-input[type="range"]').before(clone);
      $('.range-input:first-of-type').removeAttr('data-values').attr({'value': value[0], 'id': 'range-' + value[0], 'aria-label': value[0]});
      $('.range-input:last-of-type').removeAttr('data-values').attr({'value': value[1], 'id': 'range-' + value[1], 'aria-label': value[1]});
    });
    //for RANGE INPUT CHANGE VALUE
    $('.range-input:first-of-type').on('input change', function() {
      $('.range-input_label-first').val($(this).val());
    });
    $('.range-input:last-of-type').on('input change', function() {
      $('.range-input_label-last').val($(this).val());
    });
    //for RANGE INPUT RESET
    $('#cancel__buton').on('click', function() {
      var valFirst = $('.range-input_label-first').attr('value'),
        valLast = $('.range-input_label-last').attr('value');
      $('.range-input_label-first').val(valFirst);
      $('.range-input_label-last').val(valLast);
    });
  }

  //for add and delete preview images on input[type="file"]
  //    $('input[type="file"]').on('change', function (e) {
  //        var countFiles = $(this)[0].files.length,
  //            imgPath = $(this)[0].value,
  //            extn = imgPath.substring(imgPath.lastIndexOf('.') + 1).toLowerCase(),
  //            image_holder,
  //            file_count = $(this).parents('.form__group-file').find('.file-not span'),
  //            countImg = $(this).parents('.form__group-file').find('.file_box img').length,
  //            maxFileSizeImg = $('input[name="MAX_FILE"]').attr('data-maxSizeImg'),
  //            maxFileSizeVideo = $('input[name="MAX_FILE"]').attr('data-maxSizeVideo'),
  //            maxFileSum = $('input[name="MAX_FILE"]').attr('data-maxSum'),
  //            countmaxFileImg = 0,
  //            countmaxFileVideo = 0,
  //            maxFileFlag = true,
  //            acceptFile = $(this).attr('accept');
  //        if($(this).parents().hasClass('profile') == true){
  //            image_holder = $(this).parents().find('.file_box');
  //        }else{
  //            image_holder = $(this).parents('.form__group-file').find('.file_box');
  //        }
  //
  //        if ((countFiles + countImg) <= maxFileSum) {
  //            //for IMG format file
  //            if ((extn == "gif" || extn == "png" || extn == "jpg" || extn == "jpeg") && (acceptFile.search('image/*') != -1) ){
  //                if (typeof (FileReader) != "undefined") {
  //                    for (var i = 0; i < countFiles; i++) {
  //                        var reader = new FileReader();
  //                        reader.onload = function (e) {
  //                            $("<div class='file_preview' data-del='delete'><div class='file_preview_box'><img class='file_image' src='" + e.target.result + "'></div><span>"+ imgPath.replace("C:\\fakepath\\", '') + "</span></div>").appendTo(image_holder);
  //                            //$(".article_text").append("<img class='article_image' src='" + e.target.result + "'>");
  //                        }
  //                        if (maxFileSizeImg > $(this)[0].files[i].size) {
  //                            image_holder.show();
  //                            reader.readAsDataURL($(this)[0].files[i]);
  //                            if (maxFileSum >= countFiles > 0) {
  //                                $(this).parents('.form__group-file').find(".file_del").removeClass('hidden');
  //                                $('.user_box-preview-new').css('display','block');
  //                            }
  //                        } else {
  //                            maxFileFlag = false;
  //                            ++countmaxFileImg;
  //                        }
  //                    }
  //                    if (maxFileFlag == true) {
  //                        file_count.removeClass('file-max').html('add ' + (i + countImg) + ' files');
  //                    } else {
  //                        file_count.addClass('file-max').html('<div>add ' + (countFiles - countmaxFileImg) + ' files,</div><div> ' + countmaxFileImg + ' files size up to <b>' + maxFileSizeImg / 1024 + 'kb</b></div>');
  //                    }
  //                } else {
  //                    image_holder.append(imgPath.replace("C:\\fakepath\\", ''));
  //                }
  //            }
  //            //for VIDEO format file
  //            if ((extn == "flv" || extn == "avi" || extn == "mpg" || extn == "mpeg" || extn == "wmv" || extn == "mp4" || extn == "mov") && (acceptFile.search('video/!*') != -1)) {
  //                var video = document.createElement('video');
  //                for (var i = 0; i < countFiles; i++) {
  //                    video.addEventListener('loadeddata', function(e) {
  //                        var canvas = document.createElement('canvas');
  //                        canvas.width = this.videoWidth;
  //                        canvas.height = this.videoHeight;
  //
  //                        var context = canvas.getContext('2d');
  //                        context.drawImage(video, 0, 0, this.videoWidth, this.videoHeight);
  //
  //                        var dataURL = canvas.toDataURL();
  //                        $("<div class='file_preview' data-del='delete'><div class='file_preview_box'><img class='file_image' src='" + dataURL + "'></div><span>"+ imgPath.replace("C:\\fakepath\\", '') + "</span></div>").appendTo(image_holder);
  //                        /!*console.log(this.duration); */
  //                    });
  //                    if (maxFileSizeVideo > $(this)[0].files[i].size) {
  //                        image_holder.show();
  //                        video.src = window.URL.createObjectURL(e.target.files[0]);
  //                        if (maxFileSum >= countFiles > 0) {
  //                            $(this).parents('.form__group-file').find(".file_del").removeClass('hidden');
  //                        }
  //                    } else {
  //                        maxFileFlag = false;
  //                        ++countmaxFileVideo;
  //                    }
  //                }
  //                if (maxFileFlag == true) {
  //                    file_count.removeClass('file-max').html('add ' + (i + countImg) + ' files');
  //                } else {
  //                    file_count.addClass('file-max').html('<div>add ' + (countFiles - countmaxFileVideo) + ' files,</div><div> ' + countmaxFileVideo + ' files size up to <b>' + maxFileSizeVideo / 1024 + 'kb</b></div>');
  //                }
  //            }
  //
  //        } else {
  //            file_count.removeClass('file-max').html('chose maximum files');
  //        }
  //
  //    });

  $('.file_box').on('click', '.file_preview', function() {
    $(this).toggleClass("file_preview-del");
  });
  $(".btnDelete").on("click", function() {
    var image_holder;
    if ($(this).parents().hasClass('profile') == true) {
      image_holder = $(this).parents().find('.file_box');
    } else {
      image_holder = $(this).parents('.form__group-file').find('.file_box');
    }
    image_holder.find(".file_preview-del").remove();

    var countImg = image_holder.find('img').length;
    if (countImg != 0) {
      $(this).parents('.form__group-file').find('.file-not span').html('add ' + countImg + ' files');
    } else {
      $(this).parents('.form__group-file').find(".file_del").addClass('hidden');
      $(this).parents('.form__group-file').find('.file-not span').html('no file');
      $('.user_box-preview-new').css('display', 'none');
    }
  });

  //for form pop Up
  $('.form__popUp-close, .form__popUp').on('click', function() {
    $('.form__popUp').addClass('hidden');
  });

  //for form label HOME PAGE
  function formLabel(form) {
    $(form).find('label').each(function() {
      var label = $(this),
        field = label.attr('for');
      $('#' + field).on('focus', function() {
        $(this).parent().addClass('focus');
      });
      $('#' + field).on('blur', function() {
        $(this).parent().removeClass('focus');
      });
      $('#' + field).on('keyup', function() {
        $(this).parent().toggleClass('activate', !!this.value);
      });
      $('#' + field).val() != '' ? $('#' + field).parents('.form__group').addClass('activate') : $('#' + field).parents('.form__group').removeClass('activate');
    });
  }

  formLabel('.form');

  //BEGIN VALIDATION FORM
  function validForm(name) {
    var elem = $("form :input[name='" + name + "']");
    elem.parents('.form__group').find('.form__tooltip').html('').hide();
    elem.addClass('input__valid').removeClass('input__invalid');
    elem.parents('.form__group').find('.label').removeClass('form__invalid-label');
    elem.parents('.form__group').addClass('form__valid');
    elem.parents('.form__group').find('.label').addClass('form__valid-label');
    elem.parents('.form__group').find('.g-recaptcha').addClass('input__valid').removeClass('input__invalid');
  };

  function invalidForm(name, textTooltip) {
    var elem = $("form :input[name='" + name + "']");
    elem.parents('.form__group').find('.form__tooltip').html(textTooltip).show();
    elem.addClass('input__invalid').removeClass('input__valid');
    elem.parents('.form__group').find('.label').removeClass('form__valid-label');
    elem.parents('.form__group').addClass('form__invalid');
    elem.parents('.form__group').find('.label').addClass('form__invalid-label');
    elem.parents('.form__group').find('.g-recaptcha').addClass('input__invalid').removeClass('input__valid');
  };

  function clearForm(idForm) {
    var elem = $("#" + idForm),
      notClearInput = [];
    elem.find(".file_image").remove();
    elem.find(".file_del").addClass('hidden');
    elem.find('.file-not span').html('No file selected');
    elem.find('.form__group').removeClass('form__valid form__invalid');
    elem.find('.form__group input, .form__group textarea').removeClass('input__valid');
    elem.find('.form__group .label').removeClass('form__valid-label');
    if (notClearInput.join().search(idForm) == -1) {
      elem.find('.form__group input').val('');
      elem.find('.form__group textarea.textarea').val('');
      elem.find('input[type="checkbox"]').prop('checked', false);
      grecaptcha.enterprise.reset();
    }
  };

  function validator(idForm) {
    var valid = true,
      birthdateFlag = true,
      D = new Date(),
      curentYear = D.getFullYear();
    $("#" + idForm).each(function() {
      var file = $(this);
      $('.form__group', this).find(".text-input, .textarea, .select, .check-input, #g-recaptcha-response").each(function() {
        var input = $(this),
          nameInput = input.attr('name'),
          typeInput = input.attr('type'),
          valInput = input.val(),
          requiredInput = input.hasClass('required'),
          requiredInputRegexp = ['password', 'pass2', 'pass_new', 'dob_day', 'dob_year', 'email', 'search_id'];

        switch (true) {
          case ((valInput == "") && (typeInput != 'hidden') && (requiredInput == true)): {
            if (nameInput == "dob_day") {
              birthdateFlag = false;
              console.log(birthdateFlag);
            }
            invalidForm(nameInput, 'please fill out this input field');
            valid = false;
          }
            break;
          case ((valInput == "") && (typeInput != 'hidden') && (nameInput == 'g-recaptcha-response')): {
            invalidForm(nameInput, 'Please fill up the captcha.');
            valid = false;
          }
            break;
          case ((valInput != " ") && (typeInput != 'hidden')): {
            if (requiredInput == false) {
              validForm(nameInput);
            } else {
              switch (true) {
                case (requiredInputRegexp.join().search(nameInput) == -1): {
                  validForm(nameInput);
                }
                  break;
                case (nameInput == "password"): {
                  if (valInput.match(/^(?=.*\d).{4,8}$/)) {
                    validForm(nameInput);
                  } else {
                    invalidForm(nameInput, 'Your password must contain from 4 to 8 characters and include at least one digit');
                    valid = false;
                  }
                }
                  break;
                case (nameInput == "pass2"): {
                  if (valInput == $('input[name=password]').val()) {
                    validForm(nameInput);
                  } else {
                    invalidForm(nameInput, 'please check your passwords');
                    valid = false;
                  }
                }
                  break;
                case (nameInput == "pass_new"): {
                  if (valInput.match(/^(?=.*\d).{4,8}$/)) {
                    validForm(nameInput);
                  } else {
                    invalidForm(nameInput, 'Your password must contain from 4 to 8 characters and include at least one digit');
                    valid = false;
                  }
                }
                  break;
                case (nameInput == "dob_day"): {
                  if (valInput.match(/(0[1-9]|1[0-9]|2[0-9]|3[0-1])/)) {
                    validForm(nameInput);
                  } else {
                    invalidForm(nameInput, 'please fill out this input field correctly in format "DD"');
                    valid = false;
                    birthdateFlag = false;
                  }
                }
                  break;
                case (nameInput == "dob_year"): {
                  if (valInput.match(/^(?:19|20)\d{2}$/)) {
                    if (birthdateFlag == false) {
                      $("form :input[name=" + nameInput + "]").addClass('input__valid').removeClass('input__invalid');
                    } else {
                      validForm(nameInput);
                    }
                    if ((curentYear - valInput) < 18) {
                      invalidForm(nameInput, 'please fill out this input field correctly');
                      valid = false;
                      $('.form__popUp').removeClass('hidden');
                      $('.form__popUp p').html('Access is limited, your age must exceed 18 years');
                      setTimeout(function() {
                        $('.form__popUp').addClass('hidden');
                        $('.form__popUp p').html(' ');
                      }, 2000);
                    }
                  } else {
                    invalidForm(nameInput, 'please fill out this input field correctly in format "YYYY"');
                    valid = false;
                  }
                }
                  break;
                case (nameInput == "email"): {
                  if (valInput.match(/^[\w\.]+@\w+\.((\w+\.)+)?\w+$/i)) {
                    validForm(nameInput);
                  } else {
                    invalidForm(nameInput, 'Your email must contain the "@"');
                    valid = false;
                  }
                }
                  break;
                case ((nameInput == 'search_id') || (nameInput == 'weightUser') || (nameInput == 'heightUser')): {
                  if (valInput.match(/^\d+$/)) {
                    validForm(nameInput);
                  } else {
                    invalidForm(nameInput, 'fill this field correctly, it should contain only numbers');
                    valid = false;
                  }
                }
                  break;
                default:
                  break;
              }
            }
          }
            break;
          default:
            break;
        }
      });
    });
    return valid;
  };

  function submitForm(idForm, textSuccessfully, textProblems) {
    $("#" + idForm).on("submit", function(e) {
      e.preventDefault();
      var valid = validator(idForm);
      var form = $(this);
      if (valid == true) {
        $.ajax({
          type: form.attr('method'),
          url : form.attr('action'),
          data: form.serialize()
        }).done(function() {
          $('.form__popUp').removeClass('hidden');
          $('.form__popUp p').html(textSuccessfully);
          setTimeout(function() {
            $('.form__popUp').addClass('hidden');
            clearForm(idForm);
          }, 2000);
        }).fail(function() {
          $('.form__popUp p').html(textProblems);
          $('.form__popUp').removeClass('hidden');
          setTimeout(function() {
            $('.form__popUp').addClass('hidden');
          }, 2000);
        });
        return false;
      } else {

      }
    });
  };
  //for HOME PAGE FORM
  /*$("#register__buton").click(function () {
   submitForm('register','Your message has been successfully sent.','Sorry, please, there are problems while sending a message.');
   });
   //for CONTACT US PAGE FORM
   $("#contactUs__buton").on('click', function () {
   submitForm('contactUs_form','Your message has been successfully sent.','Sorry, please, there are problems while sending a message.');
   });*/
  //for ACCOUNT SETTINGS PAGE FORM
  $("#email__buton").on('click', function() {
    $('#accountSettings_form .form__group').removeClass('form__valid form__invalid');
    $('#accountSettings_form .form__section:first-of-type .text-input').addClass('required');
    $('#accountSettings_form .form__section:last-of-type .text-input').removeClass('required');
    submitForm('accountSettings_form', 'Your email address has been successfully changed.', 'Sorry, please, there are problems while sending a message.');
  });
  $("#password__buton").on('click', function() {
    $('#accountSettings_form .form__group').removeClass('form__valid form__invalid');
    $('#accountSettings_form .form__section:first-of-type .text-input').removeClass('required');
    $('#accountSettings_form .form__section:last-of-type .text-input').addClass('required');
    submitForm('accountSettings_form', 'Your password has been successfully changed.', 'Sorry, please, there are problems while sending a message.');
  });
  $("#notifications__buton").on('click', function() {
    $('#accountSettings_form .form__group').removeClass('form__valid form__invalid');
    $('#accountSettings_form .form__section .text-input').removeClass('required');
    submitForm('accountSettings_form', 'Your changes to sending notifications successfully saved.', 'Sorry, please, there are problems while sending a message.');
  });

  //<----- end for FORM ----->
});

$('.date_mask_js').focus(function() {
  $(this).datetimepicker({
    mask   : '99.99.9999 99:99',
    format : 'd.m.Y H:i',
    minDate: '+1970/01/03',
    maxDate: '+1970/01/17'
  });
});
